import { render, staticRenderFns } from "./tenderCostList.vue?vue&type=template&id=6b4bf680&"
import script from "./tenderCostList.vue?vue&type=script&lang=js&"
export * from "./tenderCostList.vue?vue&type=script&lang=js&"
import style0 from "./tenderCostList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports